const t = {
  name: "Vietnam",
  dimensions: { width: 20, height: 20 },
  content: `
    <g>
      <path d="M16.3 18.3874C17.7911 18.3874 19 17.1786 19 15.6874C19 14.1963 17.7911 12.9874 16.3 12.9874C14.8088 12.9874 13.6 14.1963 13.6 15.6874C13.6 17.1786 14.8088 18.3874 16.3 18.3874Z" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10"/>
      <path d="M7.30002 13.6875C7.90002 14.1875 8.30002 14.8875 8.30002 15.7875C8.30002 17.2875 7.10002 18.4875 5.60002 18.4875C4.10002 18.4875 2.90002 17.2875 2.90002 15.7875C2.90002 14.9875 3.30002 14.2875 3.80002 13.7875" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10"/>
      <path d="M8 6.38708C8 6.38708 1 5.88708 1 13.3871H10L16.1 9.28748L14.5 1.28748H10" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M1.09998 6.38748L8.59998 6.28748L9.19998 9.38748" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
  `
};
export {
  t as Vietnam
};
